export default __webpack_public_path__ + "assets/images/8ad7dd16884444c171a0580730cd5ffa.png";